import { fetchApi } from "utils/baseFetcher";
import { setUiVersionCookie } from "utils/setUiVersionCookie";

// The token is requested before the cookie is set, so the request still
// goes to the current UI's API.
export const reloadWithMagicToken = async (uiVersion: "new" | "old") => {
  let magicToken: string | undefined;

  try {
    const data = await fetchApi("/api/v2/magic-tokens", { method: "POST" });
    magicToken = data?.token;
  } catch (err) {
    console.error("Failed to create magic token", err);
  }

  setUiVersionCookie(uiVersion);

  if (magicToken) {
    const url = new URL(window.location.href);
    url.searchParams.set("magic-token", magicToken);
    window.location.href = url.href;
  } else {
    window.location.href = "/login";
  }
};
